import React, { useEffect, useState } from "react";
import "./Indivisiual.css";
import { SimpleGrid } from "@chakra-ui/react";
import api from "../../utils/ApiMethod";
import { truncateAtWord } from "../../utils/constants";
import { delay, motion, useAnimation } from "framer-motion";

import { Box, Text, Image } from "@chakra-ui/react";
import { Helmet } from "react-helmet";

const Ravindran = () => {
  const [ravindranPageData, setRavindranPageData] = useState([]);

  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const handleFetchData = async () => {
    try {
      const data = await api.fetchData("/ravindran");
      setRavindranPageData(data);
      // console.log("Fetched data:", data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Sri Ravindran Shankaran (DG) | Bihar State Sports Authority | BSSA
        </title>
        <meta
          name="description"
          content="श्री रवीन्द्रण शंकरण, महानिदेशक, बिहार राज्य खेल प्राधिकरण का संदेश: बिहार खेल विकास में नई ऊंचाइयां छू रहा है। 'मेडल लाओ, नौकरी पाओ' नीति और सरकार के प्रयास से खेल जगत में प्रगति हो रही है।"
        />
      </Helmet>
      <SimpleGrid columns={[1, 1, 2, 2]} mt="20" mb="10">
        <motion.Box
          flexShrink={0}
          initial={{
            opacity: 0,
            translateX: -50,
            translateY: 0,
          }}
          whileInView={{
            opacity: 1,
            translateX: 0,
            translateY: 0,
          }}
          transition={{ duration: 0.3, delay: 1 }}
        >
          <Image
            borderRadius="lg"
            px={[5, 10, 20]}
            src={ravindranPageData[0]?.image}
            alt="Woman paying for a purchase"
            h="350px"
            w="100%"
          />
        </motion.Box>

        <Box mt={{ base: 4, md: 0 }} ml={{ md: 6 }} p="0">
          <Text
            fontWeight="bold"
            textTransform="uppercase"
            fontSize={["18", "42"]}
            letterSpacing="wide"
            color="teal.800"
            px={[4, 10, 20]}
          >
            {ravindranPageData[0]?.title}
          </Text>
          <Text
            fontWeight="bold"
            textTransform="uppercase"
            align={"right"}
            fontSize={["10", "13"]}
            letterSpacing="wide"
            color="black"
            px={[4, 10, 20]}
          >
            {ravindranPageData[0]?.designation}
          </Text>

          <Text
            mt={2}
            align={"left"}
            color="gray.500"
            px={[5, 10, 20]}
            letterSpacing="wide"
            fontWeight="bold"
            py="2"
          >
            {expanded || (ravindranPageData[0]?.paragraph?.length ?? 0) <= 850 ? (
              <p>{ravindranPageData[0]?.paragraph}</p>
            ) : (
              <p>{truncateAtWord(ravindranPageData[0]?.paragraph, 850)}...</p>
            )}
            {(ravindranPageData[0]?.paragraph?.length ?? 0) > 850 && (
              <button
                onClick={toggleExpand}
                style={{ color: "blue", fontWeight: "500" }}
              >
                {expanded ? "कम पढ़ें" : "और पढ़ें"}
              </button>
            )}
          </Text>
        </Box>
      </SimpleGrid>
    </>
  );
};
export default Ravindran;
